/**
 * Mapeo simple de tipos de documentos por país
 * Solución directa para el problema: FC debe mostrar "Factura Contingencia" en Colombia
 */

const DOCUMENT_TYPE_NAMES = {
  'CO': { // Colombia
    'FC': 'Factura Contingencia',
    'FE': 'Factura Electrónica',
    'FS': 'Factura Simple',
    'FV': 'Factura de Venta',
    'NC': 'Nota Crédito',
    'ND': 'Nota Débito',
    'TK': 'Ticket',
    'RC': 'Recibo de Caja'
  },
  'ES': { // España
    'FC': 'Factura Completa',
    'FE': 'Factura Electrónica',
    'FS': 'Factura Simplificada',
    'FV': 'Factura de Venta',
    'NC': 'Nota de Crédito',
    'ND': 'Nota de Débito',
    'TK': 'Ticket',
    'RC': 'Recibo de Caja'
  },
  'MX': { // México
    'FC': 'Factura',
    'FE': 'Factura Electrónica',
    'FS': 'Factura Simple',
    'FV': 'Factura de Venta',
    'NC': 'Nota de Crédito',
    'ND': 'Nota de Débito',
    'TK': 'Ticket',
    'RC': 'Recibo de Caja'
  }
};

/**
 * Obtiene el nombre del tipo de documento según el país
 * @param {string} docType - Código del tipo (FC, FV, etc.)
 * @param {string} countryCode - Código del país (opcional, se detecta automáticamente)
 * @returns {string} Nombre del tipo de documento
 */
export const getDocumentTypeName = (docType, countryCode = null) => {
  if (!countryCode) {
    // Obtener país de la empresa
    try {
      const company = JSON.parse(localStorage.getItem('company') || '{}');
      countryCode = company.Country_IdentificationCode || 'CO';
    } catch (e) {
      countryCode = 'CO'; // Colombia por defecto
    }
  }
  
  const countryTypes = DOCUMENT_TYPE_NAMES[countryCode] || DOCUMENT_TYPE_NAMES['CO'];
  return countryTypes[docType] || docType;
};